import { get, set } from 'lodash';
import { getColumnCaptionPath } from '@shared/utils/common-utils';
import { GridApi, ICellRendererParams } from 'ag-grid-community';
import { defaultCaptionPathForEntityRenderer } from '@config/index';
import { I18n } from '@app/i18n/strings-keys';

export abstract class AbstractBaseRenderer {
  public static captionStorageInDataPath: string = 'quick_filter_text_caption';

  public I18n = I18n;

  public params: ICellRendererParams;
  protected captionFieldPath: string = null;
  protected gridApi: GridApi;

  public abstract refresh(params: ICellRendererParams): boolean;

  public agInit(params: ICellRendererParams): void {
    this.params = params;
    this.gridApi = get(this.params, ['api', 'gridCore', 'gridApi']);
  }

  protected setCaptionForQuickFilterString?(captions: string): void {
    set(
      this,
      `params.data.${AbstractBaseRenderer.captionStorageInDataPath}.${this.getCaptionFieldPathInStorage()}`,
      captions,
    );
  }

  protected getCaptionPath?(): string {
    return getColumnCaptionPath(this.params?.colDef?.field);
  }

  private getCaptionFieldPathInStorage?(): string {
    return (
      this.captionFieldPath ||
      this.getCaptionPath() ||
      defaultCaptionPathForEntityRenderer
    );
  }
}
